import { getIn } from "formik";

export const isRequiredField = (validationSchema, name) => {
  // console.log(getIn(validationSchema.describe().fields, name).tests);
  return getIn(validationSchema.describe().fields, name) && 
    getIn(validationSchema.describe().fields, name).tests.find(
    test => test.name === 'required'
  )
};